import React from "react";
import { motion } from "framer-motion";
import {
  FaCheckCircle, FaMapMarkedAlt, FaMusic, FaBusAlt,
  FaUtensils, FaTshirt, FaPaypal, FaUniversity, FaFileAlt
} from "react-icons/fa";
import { GiJapaneseBridge, GiDrumKit } from "react-icons/gi";
import Logo from "../AllImages/MainLogo.png";

import BrushOne from "../Assets/BrushOne.png";
import BrushTwo from "../Assets/BrushTwo.png";
import BrushThree from "../Assets/BrushThree.png";
import BrushFour from "../Assets/BrushFour.png";

function BrushBackgrounds() {
  const brushes = [
    { src: BrushOne, style: { top: "6%", left: "10%", width: "100px", rotate: "-12deg" } },
    { src: BrushTwo, style: { top: "60%", right: "8%", width: "120px", rotate: "15deg" } },
    { src: BrushThree, style: { bottom: "25%", left: "12%", width: "110px", rotate: "-8deg" } },
    { src: BrushFour, style: { bottom: "10%", right: "18%", width: "130px", rotate: "10deg" } },
  ];
  return (
    <div className="absolute inset-0 z-0 pointer-events-none opacity-20">
      {brushes.map((b, i) => (
        <img
          key={i}
          src={b.src}
          alt="brush"
          className="absolute"
          style={{ ...b.style, transform: `rotate(${b.style.rotate})` }}
        />
      ))}
    </div>
  );
}

export default function JapanTourCongrats({ name }) {
  return (
    <div className="relative min-h-screen bg-gradient-to-br from-gray-100 to-gray-50 flex flex-col items-center justify-center px-6 py-16 text-center">
      <BrushBackgrounds />
      <motion.div
        initial={{ y: 40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
        className="w-full max-w-4xl bg-white rounded-3xl shadow-2xl border-2 border-red-500 p-10 z-10"
      >
        <img src={Logo} alt="Simanof Logo" className="h-20 mx-auto mb-6" />
        <motion.h1
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="text-5xl font-extrabold font-serif text-red-600 mb-4"
        >
          🎉 ¡Felicidades, {name || "Músico"}!
        </motion.h1>
        <p className="text-xl text-gray-800 mb-6">
          Has sido <span className="text-red-600 font-bold">oficialmente aceptado</span> en la <span className="font-semibold">Gira a Japón 2026</span>!
        </p>

        {/* Información del Tour */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="bg-red-50 border-l-4 border-red-600 p-6 rounded-lg mb-6"
        >
          <h2 className="text-2xl font-bold text-red-600 mb-3">Información del Tour</h2>
          <p className="text-lg text-gray-800 mb-2">3 – 12 de agosto, 2026</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left text-gray-700">
            <p className="flex items-center"><FaMapMarkedAlt className="text-red-500 mr-2" /> Tokio, Osaka, Kioto</p>
            <p className="flex items-center"><FaMusic className="text-red-500 mr-2" /> 2 Conciertos</p>
            <p className="flex items-center"><GiDrumKit className="text-red-500 mr-2" /> Clases Magistrales</p>
            <p className="flex items-center"><GiJapaneseBridge className="text-red-500 mr-2" /> Tours Guiados</p>
            <p className="flex items-center"><FaTshirt className="text-red-500 mr-2" /> Uniformes</p>
            <p className="flex items-center"><FaBusAlt className="text-red-500 mr-2" /> Transportación en Autobuses</p>
            <p className="flex items-center"><FaUtensils className="text-red-500 mr-2" /> Comidas Incluidas</p>
            <p className="flex items-center"><FaCheckCircle className="text-green-600 mr-2" /> Todo incluido excepto el boleto de avión</p>
          </div>
        </motion.div>

        {/* Plan de Pago */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="bg-white border-2 border-red-500 rounded-2xl shadow-xl p-6 mb-6"
        >
          <h2 className="text-2xl font-bold text-red-600 mb-4">Plan de Pago</h2>
          <p className="text-gray-800 text-lg mb-2">💰 <span className="font-semibold">Costo Total:</span> $3,200</p>
          <p className="text-gray-800 text-lg mb-2">🔑 <span className="font-semibold">Pago Inicial (10 de agosto, 2025):</span> $550</p>
          <p className="text-gray-800 text-lg">📆 <span className="font-semibold">Pagos Mensuales:</span> $240 desde <strong>septiembre 2025</strong> hasta <strong>julio 2026</strong></p>
        </motion.div>

        {/* Instrucciones de Pago */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="bg-red-100 border-l-4 border-red-600 p-6 rounded-lg mb-6 text-left"
        >
          <h2 className="text-2xl font-bold text-red-600 mb-3 flex items-center">
            <FaPaypal className="mr-2 text-blue-600" /> ¿Cómo Realizar tu Pago?
          </h2>
          <p className="text-gray-800 text-lg mb-3">
            Puedes pagar mediante <span className="font-semibold text-blue-600">PayPal</span> a:
          </p>
          <p className="text-xl font-bold text-gray-900 mb-4">simanofusa@gmail.com</p>

          <h3 className="text-xl font-bold text-red-600 mb-2 flex items-center">
            <FaUniversity className="mr-2 text-green-600" /> Transferencia Bancaria
          </h3>
          <p className="text-gray-800">
            <strong>Banco:</strong> Chase Bank <br />
            <strong>Titular:</strong> SIMAN ORCHESTRAL FOUNDATION <br />
            <strong>Número de Cuenta:</strong> 781985127 <br />
            <strong>ABA:</strong> 267084131 <br />
            <strong>SWIFT:</strong> CHASUS33 <br />
            <strong>Dirección:</strong> 10495 NW 12th St, Miami, FL 33172 <br />
            <strong>Teléfono:</strong> 305.593.1076
          </p>
          <p className="text-gray-700 mt-3">
            Incluye tu nombre completo y "Japan Tour 2026" en la referencia del pago.
          </p>
        </motion.div>

        {/* Contracts & Documents */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="bg-gray-50 border-2 border-gray-200 rounded-2xl shadow-lg p-6 mb-6"
        >
          <h2 className="text-2xl font-bold text-red-600 mb-4 flex items-center">
            <FaFileAlt className="mr-2 text-gray-600" /> Documentos Necesarios
          </h2>
          <p className="text-gray-700 mb-4">
            Antes de iniciar la gira, es necesario que llenes y aceptes los siguientes documentos:
          </p>
          <div className="flex flex-col space-y-3">
            <a
              href="https://drive.google.com/file/d/133rDED6pbxkNa5lPM1_UhT8AzV2MOzTh/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg shadow transition"
            >
              📄 CONTRATO DE PRESTACION DE SERVICIO
            </a>
            <a
              href="https://drive.google.com/file/d/1eeenz774krxqc1iIIpQ9LU_PYA94eXmH/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg shadow transition"
            >
              📄 POLÍTICAS DE CANCELACIÓN
            </a>
            <a
              href="https://drive.google.com/file/d/140wnrrvluzOvgfXwI_7eNkn6yAPWoAnh/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg shadow transition"
            >
              📖 REGLAMENTO GENERAL DE VIAJE
            </a>
          </div>
          <p className="mt-4 text-gray-800">
            Por favor, envía los formularios firmados a <a href="mailto:Information@simanof.org" className="text-blue-600 underline">Information@simanof.org</a>
          </p>
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.7 }}
          className="text-lg text-gray-700"
        >
          ¡Prepárate para una <span className="text-red-600 font-bold">experiencia musical inolvidable</span> por Japón – estamos emocionados de vivir esta aventura contigo!
        </motion.p>
      </motion.div>
    </div>
  );
}
